export default __webpack_public_path__ + "static/media/UMA-round.559e6b36.svg";